import { useQueryPatientProfiles } from '@/hooks/query/useQueryPatientProfiles';

import { useSessionWorkflowRuns, useWorkflows } from '@/features/workflows/hooks';
import {
  SessionWorkProjectSelector as SessionWorkProjectSelectorView,
  type SessionWorkProjectSelectorProps,
} from '@heidi/agents';
import { groupSessionRoutineRuns } from '@heidi/agents/data';

/** This session's routine runs, grouped per routine by the routines domain. */
const useSessionRoutineRunGroups = (sessionId: string) => {
  const { data, isLoading } = useSessionWorkflowRuns(sessionId);
  return { groups: groupSessionRoutineRuns(data?.runs ?? []), isLoading };
};

const useRoutines = () => useWorkflows();

const usePatientProfiles = () => useQueryPatientProfiles();

/**
 * Binds the session's Work history menu to the app: the workflows root's routine
 * reads (gated on the Work umbrella and auth) and the team's patient profiles.
 */
export const SessionWorkProjectSelector = (props: SessionWorkProjectSelectorProps) => (
  <SessionWorkProjectSelectorView
    {...props}
    useSessionRoutineRunGroups={useSessionRoutineRunGroups}
    useRoutines={useRoutines}
    usePatientProfiles={usePatientProfiles}
  />
);
